import api from "../api";
import qs from "qs";

export const pdfService = {
  async list(params) {
    return api.get(`/api/pdf`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },

  async upload(formData) {
    return api.post(`/api/pdf`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async delete(codigo) {
    return api.delete(`/denuncias/${codigo}`);
  },

  async download(codigoAnexo) {
    return api.get(`/api/anexo/${codigoAnexo}`, {
      responseType: "blob",
    });
  },
};
